import {routerMiddleware} from 'react-router-redux';
import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import persistState from 'redux-localstorage';
import {createEpicMiddleware} from 'redux-observable';
import rootEpic from '../epics';
import {history} from '../index';
import rootReducer from '../reducers';

const composeEnhancers = composeWithDevTools({
  // Specify here name, actionsBlacklist, actionsCreators and other options if needed
});

const configureStore = () => {
  return createStore(
    rootReducer,
    {},
    composeEnhancers(
      applyMiddleware(
        createEpicMiddleware(rootEpic),
        routerMiddleware(history)
      ),
      persistState(null, {
        slicer: function(paths) {
          return (state) => ({
            auth: {
              accessToken: state.auth.accessToken,
              isAuthenticated: state.auth.isAuthenticated,
              profile: state.auth.profile
            }
          })
        }
      })
    )
  );
};

export default configureStore;


// WEBPACK FOOTER //
// ./src/store/configureStore.js